import { render, staticRenderFns } from "./complain.vue?vue&type=template&id=41106deb&scoped=true&"
import script from "./complain.vue?vue&type=script&lang=js&"
export * from "./complain.vue?vue&type=script&lang=js&"
import style0 from "./complain.vue?vue&type=style&index=0&id=41106deb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41106deb",
  null
  
)

export default component.exports